import { useQuery } from '@tanstack/react-query';
import { VariantCartItem } from '../../context/useCartContext';
import useJwt from '../../utils/useJwt';

export default function useBankroll() {
  const jwt = useJwt();

  const { data } = useQuery<number, Error>(['account/bankroll', { jwt }], {
    enabled: !!jwt,
  });

  if (data && (window as any).updateMiles) (window as any).updateMiles(data);

  return { data };
}

export const useHasEnough = () => {
  const { data: bankroll } = useBankroll();

  function hasEnough(variant: VariantCartItem) {
    const price = variant.priceOverwrite
      ? variant.priceOverwrite
      : variant.price;

    if ((bankroll ?? 0) - variant.quantity * price.milesAmount >= 0) {
      return true;
    }
    return false;
  }
  return hasEnough;
};
